import { Characters } from './unicode.helper';

export const truncateMiddle = (value: string) => {
    if (value.length <= 6) {
        return value;
    }

    return `${value.slice(0, 3)}${Characters.HORIZONTAL_ELLIPSIS}${value.slice(-3)}`;
};
